/**
 * Learners — the People module, opened on the people taking courses here.
 *
 * The same module as Team (`admin/people/AdminPeople`) with a different preset. A
 * learner directory that could not also show the instructor enrolled beside them would
 * be a second, quietly different answer to "who is in this academy"; there is one list,
 * and this is one way into it.
 */

import AdminPeople from '../people/AdminPeople';

export default function AdminLearners() {
  return <AdminPeople preset="learners" />;
}
